import React, { useContext } from 'react'
import {
  PaperAnswerReq,
  PaperBlock,
  PaperReview,
} from 'packages/sdks-next/growp'
import { CreateReviewParams, CreateReviewPayload, QuizMode } from './types'

export const AnswersContext = React.createContext<{
  mode: QuizMode
  answers: PaperAnswerReq[]
  setAnswers: (v: PaperAnswerReq[]) => void
  reviews: PaperReview[]
  onCreateReview: (
    params: CreateReviewParams,
    payload: CreateReviewPayload
  ) => void
  isReviewed: boolean
  blocks: PaperBlock[]
  showAnswer: boolean
  showScore: boolean
}>({
  mode: QuizMode.Answering,
  answers: [],
  setAnswers: () => null,
  reviews: [],
  onCreateReview: () => null,
  isReviewed: false,
  blocks: [],
  showAnswer: false,
  showScore: true,
})

export function useAnswersManagement() {
  const context = useContext(AnswersContext)
  if (!context) {
    throw new Error('AnswersContext not exsist')
  }
  const {
    setAnswers,
    answers,
    mode,
    reviews,
    onCreateReview,
    isReviewed,
    blocks,
    showAnswer,
    showScore,
  } = context
  return {
    mode,
    answers,
    setAnswers,
    reviews,
    onCreateReview,
    isReviewed,
    blocks,
    showAnswer,
    showScore,
  }
}
